import {API_URL, API_URL_STORY} from '../constants'
import { apiFetch } from './client';
import {setNotifications} from "../store/slices/notifications";
import { Amplify, Auth } from "aws-amplify";

export const stringifyParameters = (parameters) => {
    const query = [];
    try {
        Object.keys(parameters)
            .filter((key) => parameters[key])
            .forEach((key) => {
                switch (key) {
                    case 'page':
                    case 'statusId':
                    case 'occasionId':
                    case 'recipientId':
                    case 'authorId':
                    case 'productId':
                    case 'isPublished': {
                        // @ts-ignore
                        query.push(`${key}=${parameters[key]}`);
                        break;
                    }
                    case 'perPage': {
                        // @ts-ignore
                        query.push(`limit=${parameters[key]}`);
                        break;
                    }
                    case 'tags': {
                        // @ts-ignore
                        query.push(`tagIds=${parameters[key]}`);
                        break;
                    }
                    default: {
                        break;
                    }
                }
            });
    } catch (error) {
        console.warn('Looks like something wrong with fetch products url parameters');
    }
    console.log('PARAMS',parameters);
    console.log(query)
    return `${query.join('&')}`;
};


export const getAllStories = async (queryParams) => {
    const res = await apiFetch(`${API_URL_STORY}/stories?${stringifyParameters(queryParams)}`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getStoryById = async (id) => {
    const res = await apiFetch(`${API_URL_STORY}/stories/${id}`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};
export const updateStoryById = async (id, data) => {
    const res = await apiFetch(`${API_URL_STORY}/stories/${id}`,{
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({...data})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const createStory = async (data) => {
    const res = await apiFetch(`${API_URL_STORY}/stories`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({...data})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};
export const getStoryGiftCards = async (data) => {
    const res = await apiFetch(`${API_URL_STORY}/gift-cards?gfStoryId=${data.id}&${stringifyParameters(data.queryParams)}`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const createGiftCard = async ({data,  onSuccess}) => {
    const res = await apiFetch(`${API_URL_STORY}/gift-cards`,{
        method: "POST",
        // mode: "no-cors", // no-cors, *cors, same-origin
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
            // 'Access-Control-Allow-Origin': '*',
        },
        body: JSON.stringify({...data})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    const rest = await res.json();
    if (onSuccess) {
        onSuccess(rest);
    }
    return rest;
};

export const disableGiftCard = async ({id,  onSuccess}) => {
    const res = await apiFetch(`${API_URL_STORY}/gift-cards/${id}/disable`,{
        method: "POST",
        // mode: "no-cors", // no-cors, *cors, same-origin
        headers: {
            "Content-Type": "application/json",
            // 'Content-Type': 'application/x-www-form-urlencoded',
            // 'Access-Control-Allow-Origin': '*',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    const rest = await res;
    if (onSuccess) {
        onSuccess(rest);
    }
    return rest;
};

export const getS3Url = async ({blob,  onSuccess}) => {
    const res = await fetch(`${API_URL_STORY}/open/media/signed-url`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({type: blob.type})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    const data = await res.json();
    return S3Uploud(blob, data, onSuccess);
};

export const S3Uploud = async (blob, data, onSuccess) => {
    const res = await fetch(`${data.signed_url}`,{
        method: "PUT",
        headers: {
            "Content-Type": blob.type,
            "Content-Disposition": `attachment; filename="${data.file_name}"`
        },
        body: blob
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    if (onSuccess) {
        onSuccess(data);
    }
    return res;
};

export const getVideoUrl = async () => {
    const res = await fetch(`${API_URL_STORY}/open/media/video`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({title: 'story video',collectionId: 'de3b0674-d079-4a7d-a6e7-0ab1996d07e9'})
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getStoryStats = async () => {
    const res = await apiFetch(`${API_URL_STORY}/analytics/stories/stats`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getStoryGraphData = async (queryParams) => {
    const params = new URLSearchParams();
    if (queryParams.type) params.append('type', queryParams.type);
    if (queryParams.days) params.append('days', queryParams.days.toString());
    if (queryParams.createdAt_min) params.append('createdAt_min', queryParams.createdAt_min);
    if (queryParams.createdAt_max) params.append('createdAt_max', queryParams.createdAt_max);

    const res = await apiFetch(`${API_URL_STORY}/analytics/stories/graph?${params.toString()}`,{
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};


